import {
    DICTIONARY_ORGANIZATIONS_POST_ADD,
    DICTIONARY_PORT_POST_ADD,
    DICTIONARY_VESSELS_POST_ADD,
    DICTIONARY_CITY_POST_ADD
} from "../../Api/axios";

export const selectApiPostRequestDictionary = (value) => {

    const requestList = {
        'vessel' : DICTIONARY_VESSELS_POST_ADD,
        'port' : DICTIONARY_PORT_POST_ADD,
        'shipper' : DICTIONARY_ORGANIZATIONS_POST_ADD,
        'shipowner' : DICTIONARY_ORGANIZATIONS_POST_ADD,
        'city': DICTIONARY_CITY_POST_ADD
    }

    for (let key in requestList) {
        if (value === key) {
            return requestList[key];
        }
    }

    return selectApiPostRequestDictionary;
}
